import MobileOnlyLink from '@acorn-portal/shared/src/components-v2/mobile-only-link';
import { Typography } from '@mui/material';

interface IClaimNotificationContent {
	contactNumber: string;
}

/**
 * - Simple component to display a notification when a policy is blocked by a claim
 */
const ClaimNotificationContent = ({ contactNumber }: IClaimNotificationContent) => {
	return (
		<Typography>
			It looks like there&apos;s a claim on your policy. Please call us
			{contactNumber ? (
				<>
					{' '}
					on <MobileOnlyLink href={`tel:${contactNumber}`} text={contactNumber} />
				</>
			) : null}{' '}
			and we&apos;ll help you with your cancellation request.
		</Typography>
	);
};

export default ClaimNotificationContent;
